module.exports = "/_next/static/images/cfab77cfec7ba65fde2178b85fb9cf6a-credit-pre-ric.svg";